import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-multi-select-list',
  templateUrl: './download-list.component.html',
  styleUrls: ['./download-list.component.css']
})
export class DownloadListComponent {

   @Output() submitData = new EventEmitter<any>();
   @Output() closeDialog = new EventEmitter<any>();
   selectedItems: any[] = [];
   parentSelector = false;

   constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) {
   }

   onItemAllSelect(check: any) {
      for (let i = 0; i < this.data.list.length; i++) {
         this.data.list[i].selected = check.checked;
         const index = this.selectedItems.indexOf(this.data.list[i]);
         if (this.data.list[i].selected) {
            if (index === -1) {
               this.selectedItems.push(this.data.list[i]);
            }
         } else {
            if (index !== -1) {
               this.selectedItems.splice(index, 1);
            }
         }
      }
   }

   onItemSelect(item: any) {
      item.selected = !item.selected;
      const index = this.selectedItems.indexOf(item);
      if (item.selected) {
         if (index === -1) {
            this.selectedItems.push(item);
         }
      } else {
         if (index !== -1) {
            this.selectedItems.splice(index, 1);
         }
      }
   }

   onSubmit() {
      this.submitData.emit(this.data.list);
   }
}
